import {Store} from 'vuex';
import {getModule} from 'vuex-module-decorators';
import {SessionModule} from './session';
import {CustomerProfileModule} from './customerProfile';
import {DeepLinkModule} from './deepLink';
import {FeaturedItemModule} from './featuredItem';
import {ItemFavoriteModule} from './itemFavorite';
import {CurbsideLocationsModule, LocationModule} from './location';
import {LocationDiscountModule} from './locationDiscount';
import {LocationHoursModule} from './locationHours';
import {MenuModule} from './menu';
import {OrderModule, TicketsModule} from './order';
import {PaymentAccountModule} from './paymentAccount';
import {RecentItemModule} from './recentItem';
import {SimpleMenuModule} from './simpleMenu';
import {SimpleTicketModule} from './simpleTicket';
import {SpecialsModule} from './specials';
import {TrendingItemModule} from './trendingItem';
import {UIModule} from './ui';
import {VehiclesModule} from './vehicles';
import {HistoryModule} from './history/history.store';
import {ContainerTransitionMappingModule} from './containerTransitionMapping/containerTransitionMapping.store';
import {AnimationModule} from './animation.store';

// To add a new store you need to add it below:
// let MyStore: MyStoreModule;
// Then you need to add it below in the vuexHook function:
// MyStore = getModule(MyStoreModule, store);
// Then you need to add it to the export below and also register it in the store.ts file
// In the store.ts file you need to make the key the same as the name you put in the @Module decorator

let AnimationStore: AnimationModule;
let CustomerProfileStore: CustomerProfileModule;
let CurbsideLocationStore: CurbsideLocationsModule;
let DeepLinkStore: DeepLinkModule;
let FeaturedItemStore: FeaturedItemModule;
let ItemFavoriteStore: ItemFavoriteModule;
let LocationStore: LocationModule;
let LocationDiscountStore: LocationDiscountModule;
let LocationHoursStore: LocationHoursModule;
let MenuStore: MenuModule;
let OrderStore: OrderModule;
let TicketsStore: TicketsModule;
let PaymentAccountStore: PaymentAccountModule;
let RecentItemStore: RecentItemModule;
let SessionStore: SessionModule;
let SimpleMenuStore: SimpleMenuModule;
let SimpleTicketStore: SimpleTicketModule;
let SpecialsStore: SpecialsModule;
let TrendingItemStore: TrendingItemModule;
let UIStore: UIModule;
let VehiclesStore: VehiclesModule;
let HistoryStore: HistoryModule;
let ContainerTransitionMappingStore: ContainerTransitionMappingModule;


export const vuexHook = (store: Store<any>) => {
	AnimationStore = getModule(AnimationModule, store);
	SessionStore = getModule(SessionModule, store);
	CustomerProfileStore = getModule(CustomerProfileModule, store);
	CurbsideLocationStore = getModule(CurbsideLocationsModule, store);
	DeepLinkStore = getModule(DeepLinkModule, store);
	FeaturedItemStore = getModule(FeaturedItemModule, store);
	ItemFavoriteStore = getModule(ItemFavoriteModule, store);
	LocationStore = getModule(LocationModule, store);
	LocationDiscountStore = getModule(LocationDiscountModule, store);
	LocationHoursStore = getModule(LocationHoursModule, store);
	MenuStore = getModule(MenuModule, store);
	OrderStore = getModule(OrderModule, store);
	TicketsStore = getModule(TicketsModule, store);
	PaymentAccountStore = getModule(PaymentAccountModule, store);
	RecentItemStore = getModule(RecentItemModule, store);
	SimpleMenuStore = getModule(SimpleMenuModule, store);
	SimpleTicketStore = getModule(SimpleTicketModule, store);
	SpecialsStore = getModule(SpecialsModule, store);
	TrendingItemStore = getModule(TrendingItemModule, store);
	UIStore = getModule(UIModule, store);
	VehiclesStore = getModule(VehiclesModule, store);
	HistoryStore = getModule(HistoryModule, store);
	ContainerTransitionMappingStore = getModule(ContainerTransitionMappingModule, store);
};


export {
	AnimationStore,
	CustomerProfileStore,
	CurbsideLocationStore,
	DeepLinkStore,
	FeaturedItemStore,
	ItemFavoriteStore,
	LocationStore,
	LocationDiscountStore,
	LocationHoursStore,
	MenuStore,
	OrderStore,
	TicketsStore,
	PaymentAccountStore,
	RecentItemStore,
	SessionStore,
	SimpleMenuStore,
	SimpleTicketStore,
	SpecialsStore,
	TrendingItemStore,
	UIStore,
	VehiclesStore,
	HistoryStore,
	ContainerTransitionMappingStore
};
